import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  FlatList,
} from "react-native";
import { Caret, Check } from "../../../../../../assets";

const fonts = [
  "Arial",
  "Trebuchet MS",
  "Times New Roman",
  "Garamond",
  "Courier New",
  "Brush Script MT",
  "DM Sans",
  "Work Sans",
  "Inter",
  "Spline Sans",
  "Instrument Serif",
  "EBGaramond",
  "Montserrat",
];

type FontContentProps = {
  textFont: string;
  onSelect: (textFont: string) => void;
};

const FontContent: React.FC<FontContentProps> = ({ textFont, onSelect }) => {
  const renderFontItem = ({ item }: { item: (typeof fonts)[number] }) => (
    <TouchableOpacity style={styles.fontItem} onPress={() => onSelect(item)}>
      <Text
        style={{
          fontFamily: item,
          fontSize: 12,
        }}
      >
        {item}
      </Text>
      {textFont === item && <Check />}
      {textFont !== item && <Caret direction={"right"} />}
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <FlatList
        data={fonts}
        keyExtractor={(item) => item}
        renderItem={renderFontItem}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    maxWidth: 280,
  },
  fontItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 3,
  },
});

export default FontContent;
